module.exports = __webpack_public_path__ + "img/list-ul.44ea5f26.svg";